// @ts-check

import React, { useEffect, useState } from 'react';
import { Mappedin, MapView } from '@mappedin/mappedin-js';


  
/**
 * @param {any} props
 */
const MapLevelSelectorOverlay = (props) => {

  // console.log('=========== OVERLAY RENDER ===> ', props);
  
  /** @type {MapView | undefined} */
  let mapView = props.mapView;
  if (!mapView) {
    return null;
  }
  
  

  /** 
  * @type {[string | null, Function]}
  */
  let [currentMapId, setCurrentMapId] = useState(null);


  /**
   * @param {MapView | undefined} mapView
   */
  let getOverlayContent = (mapView) => {
    if (!mapView) {
      return null;
    }
    
    let venue = mapView.venue;
    if (!venue) {
      return null;
    }
    
    // console.log('=========== OVERLAY GET ===> ', props, mapView.currentMap.id);
    
    // Set map id state on first load.
    if (currentMapId === null) {
      if (mapView.currentMap.id) {
        setCurrentMapId(mapView.currentMap.id);
      }
    }

    // Order maps by elevation.
    let maps = venue.maps.slice().sort((a, b) => b.elevation - a.elevation);
    
    return (
      <>
        {/* <div>OVERLAY !!!</div> */}

        <div className='live-map-overlay-level-chooser-buttons'>
          {
            maps.map((m) => {

              let isCurrent = m.id === currentMapId;
              let className = isCurrent ? 'current' : '';

              return (
                <div key={m.id}>
                  <button className={className}
                    onClick={(e) => {
                      e.preventDefault();
                      mapView?.setMap(m);
                      setCurrentMapId(m.id);
                    }}
                  >
                    {m.shortName}
                  </button>

                </div>
              );
            })
          }

        </div>
      </>
    );
  };



  /////////////////////////////////////////
  // This effect fixes the issue with the 
  // button states not updating when the
  // map Link (venue) is changed.
  // 
  useEffect(() => {
    // console.log('=========== OVERLAY UPDATE ===> ', props, mapView?.currentMap.id);
    setCurrentMapId(mapView?.currentMap.id);
    
    return () => {
      // console.log('=========== OVERLAY UNMOUNT ===> ', props, mapView?.currentMap.id);
    };
    
  }, [props, mapView?.currentMap.id]);


  return (
    <div className="live-map-overlay-level-chooser">
      {getOverlayContent(mapView)}
    </div>
  );

};


export default MapLevelSelectorOverlay;


